import React from 'react';
import { observer } from 'mobx-react';
import { ImportListTemplate } from 'themes/application/import/pages';
import { setCurrentView } from 'core/utils';
import { ImportViewStore } from 'application/import/stores';

@setCurrentView((rootStore) => new ImportViewStore(rootStore), 'listViewStore')
@observer
class ImportList extends React.Component {
    render() {
        return <ImportListTemplate {...this.props} />
    }
}

export default ImportList;